const Namespace = "fmc";
export { Namespace };
